export default "__VITE_ASSET__310003bb__"